<template>
  <div>
    <!--<div class="h-title-con">-->
      <!--<div class="h-title">-->
        <!--<span class="title-text"></span>-->
      <!--</div>-->
      <!--<div class="h-button-warpper">-->
        <!--<span class="orgBtn" @click="save">保存</span>-->
        <!--<span class="orgBtn" @click="back(false)">取消</span>-->
      <!--</div>-->
    <!--</div>-->
    <form-header :pageTitle="(id?'编辑':'新增')+'开单客户代号匹配清单'" @save="save('ruleForm')" style="margin: 0 20px;"></form-header>
    <div class="white-bg-radius w-label">
        <el-form :model="mainForm" :rules="rules" ref="form"
                 label-position="left" label-width="180px" class="demo-ruleForm" style="width: 100%;padding-top: 20px">
          <el-form-item label="系统：" prop="system">
            <el-select v-model="mainForm.system" :disabled="disabled" value-key="id" placeholder="请选择" @change="selectBlur" @blur="selectBlur" :clearable="true">
              <el-option
                v-for="item in systems"
                :key="item.id"
                :label="item.code + ' ' + item.name"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="开单客户代号：" prop="customerCode" class="clickable ww-input-dia">
            <el-input
              v-model="mainForm.customerCode"
              placeholder="请选择"
              class="input"
              suffix-icon="el-icon-tickets"
              @focus="openSAPDialog(false)"
              :disabled="disabled"
              :readonly="true"
            >
              <i v-if="mainForm.sapCustomerCode && !disabled" class="el-icon-error"  slot="append" @click.stop.prevent="clear(0)"></i>
            </el-input>
          </el-form-item>

          <el-form-item label="开单客户名称：">
            <div style="width: 600px" class="font12">{{mainForm.customerName}}</div>
          </el-form-item>
          <el-form-item label="送货分公司：">
            <div style="width: 300px" class="font12">{{mainForm.wwDcompanyCode + '  ' +mainForm.wwDcompanyName}}</div>
          </el-form-item>
          <el-form-item label="开单分公司：">
            <div style="width: 300px" class="font12">{{mainForm.wwOcompanyCode + '  ' +mainForm.wwOcompanyName }}</div>
          </el-form-item>
          <el-form-item label="开单渠道名称：">
            <div class="font12">{{mainForm.wwOpeningOrderChannel}}</div>
          </el-form-item>

          <!--<el-form-item label="是否冻结：" prop="frozen">-->
            <!--<div class="input font12">{{mainForm.frozen}}</div>-->

            <!--&lt;!&ndash;<el-radio-group v-model="mainForm.frozen" :disabled="true">&ndash;&gt;-->
              <!--&lt;!&ndash;<el-radio v-show="mainForm.frozen == item.value" v-for=" (item,index) in isUsedList" :key="index" :label="item.value">{{item.label}}</el-radio>&ndash;&gt;-->
            <!--&lt;!&ndash;</el-radio-group>&ndash;&gt;-->
          <!--</el-form-item>-->

          <!--<el-form-item label="是否删除：" prop="deleted" >-->
            <!--<div class="input font12">{{mainForm.deleted}}</div>-->
            <!--&lt;!&ndash;<el-radio-group v-model="mainForm.deleted" :disabled="true">&ndash;&gt;-->
              <!--&lt;!&ndash;<el-radio  v-show="mainForm.frozen == item.value" v-for=" (item,index) in isDeleted" :key="index" :label="item.value">{{item.label}}</el-radio>&ndash;&gt;-->
            <!--&lt;!&ndash;</el-radio-group>&ndash;&gt;-->
          <!--</el-form-item>-->

          <el-form-item label="开单送达方代号："
                        prop="sysSapSendCode"
                        class="clickable"
          >
            <el-input
              v-model="mainForm.sysSapSendCode"
              placeholder="请选择"
              class="input ww-input-dia"
              :disabled="disabled"
              suffix-icon="el-icon-tickets"
              @focus="openSAPDialog(1)"
              :readonly="true"
            >
              <i v-if="mainForm.sysSapSendCodeName && !disabled" class="el-icon-error"  slot="append" @click.stop.prevent="clear(1)"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="开单送达方名称：">
            <div style="width: 600px" class="font12">{{mainForm.sysSapSendCodeName}}</div>
          </el-form-item>
          <el-form-item label="开单送达方优先级序号：" prop="sort">
            <el-select v-model="mainForm.sort" @change="selectSortBlur"  @blur="selectSortBlur" clearable>
              <el-option v-for="(item,index) in sortList" :label="item.label" :value="item.value" :key="index">
                {{item.label}}
              </el-option>
            </el-select>
          </el-form-item>

          <!--订单别：-->
          <el-form-item label="订单别：" prop="orderType">
            <el-radio-group v-model="mainForm.orderType">
              <el-radio v-for=" (item,index) in orderList" :key="index" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <!--允收货龄-->
          <el-form-item label="允收货龄：" prop="goodAge">
            <el-input  v-model="mainForm.goodAge"  placeholder="请输入" :min="1">
              <div slot="prepend">1/
              </div>
            </el-input>
          </el-form-item>
          <!--SAP开单分类文本：-->
          <el-form-item label="开单分类文本：" prop="sysSapText">
            <el-input v-model="mainForm.sysSapText" maxlength="20"  :placeholder="placeholder20"></el-input>
          </el-form-item>
          <!--系统统仓/门店代号-->
          <el-form-item label="系统统仓/门店代号：" prop="sysStoreCode">
            <el-input v-model="mainForm.sysStoreCode" maxlength="20" :placeholder="placeholder20"></el-input>
          </el-form-item>
          <!--系统统仓/门店名称：-->
          <el-form-item label="系统统仓/门店名称：" prop="sysStoreName">
            <el-input v-model="mainForm.sysStoreName" maxlength="15" :placeholder="placeholder15"></el-input>
          </el-form-item>
          <!--系统送货地代号：-->
          <el-form-item label="系统送货地代号：" prop="sysDestinationCode">
            <el-input v-model="mainForm.sysDestinationCode" maxlength="20" :placeholder="placeholder20"></el-input>
          </el-form-item>
          <!--系统送货地名称：-->
          <el-form-item label="系统送货地说明：" prop="sysDestinationRemark">
            <el-input v-model="mainForm.sysDestinationRemark" maxlength="15" :placeholder="placeholder15"></el-input>
          </el-form-item>
          <!--系统其他判断字段：-->
          <el-form-item label="系统其他判断字段：" prop="sysOther">
            <el-input v-model="mainForm.sysOther" :placeholder="placeholder20" maxlength="20"></el-input>
          </el-form-item>
        </el-form>
      <searchDialog ref="dlg"></searchDialog>
    </div>
  </div>
</template>
<script>
  // import { mapGetters } from 'vuex'
  import formHeader from '../components/form-header'

  import commonMixin from '@/mixins/common.js'
  import searchDialog from '../components/search-dialog'
  import { methodPost, methodGet } from '../../api/request'
  const isNumber = (rule, value, callback) => {
    if (!value) {
      return callback(new Error('不能为空'));
    }
    try {
      value -= 0;
    } catch (e) {
      callback(new Error('请输入数字值'));
    }
    if (!Number.isInteger(value)) {
      callback(new Error('请输入数字值'));
    } if (value < 0) {
      callback(new Error('数字值不能为负值'));
    } else {
      callback();
    }
  };
  const isNumberAndAbc = (rule, value, callback) => {
    const reg = /^[0-9a-zA-Z]+$/
    if (!value) {
      callback();
    }
    if (!reg.test(value)) {
      callback(new Error('请输入数字和字母的组合'));
    } else {
      callback();
    }
  }
  export default {
    name: 'add',
    mixins: [commonMixin],
    data() {
      return {
        showHide: false,
        showKDHide: false,
        id: this.$route.query.id,
        systems: [],
        placeholderDefault: '请输入',
        placeholder15: '请输入，最多15个字符',
        placeholder20: '请输入，最多20个字符',
        isDeleted: [
          { label: 'Y', value: 1 },
          { label: 'N', value: 0 }
        ],
        isUsedList: [
          { label: 'Y', value: 'Y' },
          { label: 'N', value: 'N' }
        ],
        orderList: [
          { label: 'W统仓', value: 'W' },
          { label: 'D门店', value: 'D' }
        ],
        sortList: [
          { label: '1', value: 1 },
          { label: '2', value: 2 }
        ],
        mainForm: {
          sysId: '',
          system: null,
          sysCode: '', // 系统代号
          sysName: '', // 系统名称
          sapCustomerCode: '', // SAP开单客户Code + SAP开单客户名称
          customerCode: '', // SAP开单客户Code
          customerName: '', // SAP开单客户名称
          sysSapSendCode: '', // SAP开单送达方代号
          sysSapSendCodeName: '',
          wwDcompanyCode: '', // 达能送货分公司
          wwDcompanyName: '', // 达能开单分公司名称
          wwOcompanyCode: '', // 达能开单分公司
          wwOcompanyName: '', // 达能开单分公司名称
          wwOpeningOrderChannel: '', // 达能开单渠道
          frozen: '', // 是否冻结
          deleted: '', // 是否删除
          goodAge: '', // 允收货龄
          sort: '', // 匹配优先级序号
          sysSapText: '', // SAP开单分类文本
          orderType: 'W', // 订单别
          sysOther: '', // 系统其他判断字段
          sysDestinationRemark: '', // 系统送货地说明
          sysDestinationName: '', // 系统送货地名称
          sysDestinationCode: '', // 系统送货地代号
          sysStoreName: '', // 系统统仓/门店名称
          sysStoreCode: ''// 系统统仓/门店代号
        },
        ruleForms: [],
        rules: {
          system: [ // 系统code
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          orderType: [ // 订单别
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          sort: [ // 序号
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          sysSapSendCode: [ // 序号
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          customerCode: [ // SAP开单客户
            { required: true, message: '此项为必填项', trigger: 'blur' }
          ],
          goodAge: [ // 订单别
            { required: true, message: '此项为必填项', trigger: 'blur' },
            { validator: isNumber, trigger: 'blur' }
          ],
          sysDestinationCode: [ // 系统送货地代号
            { validator: isNumberAndAbc, trigger: 'blur' }
          ],
          sysStoreCode: [ // 系统统仓/门店代号
            { validator: isNumberAndAbc, trigger: 'blur' }
          ]
        }
      }
    },
    components: {
      searchDialog,
      formHeader
    },
    computed: {
      disabled() {
        return !!this.id
      }
    },
    methods: {
      fieldsToValidate(val) {
        const fieldsToValidate = [val];
        const _self = this;
        Promise.all(fieldsToValidate.map(item => {
          const p = new Promise(function(resolve, reject) {
            _self.$refs['form'].validateField(item, (error) => {
              resolve(error)
            })
          });
          return p;
        })).then((data) => {
          console.info(data)
        })
      },
      selectBlur() {
        if (!this.mainForm.system) {
          this.fieldsToValidate('system')
          this.$refs.form.validateField(['system'])
        } else {
          this.$refs.form.clearValidate(['system'])
        }
      },
      selectSortBlur() {
        if (!this.mainForm.sort) {
          this.fieldsToValidate('sort')
          this.$refs.form.validateField(['sort'])
        } else {
          this.$refs.form.clearValidate(['sort'])
        }
      },
      clear(type) {
        if (type === 0) {
          this.mainForm.sapCustomerCode = ''
          this.mainForm.customerCode = ''
          this.mainForm.customerName = ''
          // 送货分公司代号
          this.mainForm.wwDcompanyCode = ''
          this.mainForm.wwDcompanyName = ''
          // 开单分公司代号
          this.mainForm.wwOcompanyCode = ''
          this.mainForm.wwOcompanyName = ''
          this.mainForm.deleted = ''
          this.mainForm.frozen = ''
          // 达能开单渠道分销渠道代号
          this.mainForm.wwOpeningOrderChannel = ''
          this.mainForm.sysSapSendCodeName = ''
          this.mainForm.sysSapSendCode = ''
          // this.$refs.form.validateField('customerCode');
          this.fieldsToValidate('customerCode')
        } else if (type === 1) {
          this.mainForm.sysSapSendCodeName = ''
          this.mainForm.sysSapSendCode = ''
        }
      },
      back(isRefresh) {
        // const path = '/config/%2Ftemplate%2Fmodule%2Fwantwant%2Fsap_customerbill_list.json'
        // this.goBack(path)
        if (isRefresh) {
          this._gobackRefresh(this, this.$route.fullPath)
        }
      },
      save() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitForm()
          } else {
            console.log('error submit!!');
          }
        });
      },
      submitForm() {
        const param = Object.assign(this.mainForm)
        if (this.id) {
          param['id'] = parseInt(this.id)
        }
        param['sysCode'] = this.mainForm.system.code
        param['sysName'] = this.mainForm.system.name
        methodPost('/account/saveOrUpdateCustomerBill', param).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.back(1)
          } else {
            this.$message.error(res.message || '出错了！');
          }
        }).catch(err => {
          console.error(err)
          this.$message.error(err.message || '出错了！');
        })
      },
      openSAPDialog(isSend) {
        const option = {
          searchFieldName: 'name',
          dlgTitle: '选择开单客户',
          url: '/custbill/findCustSellerList',
          additionalParams: {},
          emptyMessage: '请选择开单客户',
          emptyErrorText: '该系统无匹配的开单客户代号',
          tableColumns: [
            { name: 'kunnr1', label: '开单送达方代号', width: 100 },
            { name: 'name', label: '开单送达方名称', type: 'dynamicColumnWidth', align: 'left' }
          ],
          searchTitle: '开单客户:',
          placeholder: '请输入开单客户代号或名称',
          idField: 'kunnr1'
        }
        if (isSend) { // 开单送达方选择
          if (!this.mainForm.customerCode) {
            this.$message.error('请先选择开单客户');
            return
          }
          option.emptyErrorText = ''
          option.emptyMessage = '请选择开单送达客户送达方'
          option.additionalParams = {
            kunnr: this.mainForm.customerCode
          }
          option.searchFieldName = 'name1'
          option.dlgTitle = '开单送达方'
          option.url = '/custbill/findCustServerList'
          option.idField = 'kunnr1'
        } else {
          option.tableColumns = [
            { name: 'kunnr', label: '开单客户代号', width: 100 },
            { name: 'name', label: '开单客户名称', width: 140, type: 'dynamicColumnWidth', align: 'left' },
            // { name: 'lifnr', label: '送货分公司代号' },
            { name: 'lifnrName', label: '送货分公司名称' },
            // { name: 'vkorg', label: '开单分公司代号' },
            { name: 'vkorgName', label: '开单分公司名称' },
            // { name: 'spart', label: '开单渠道代号' },
            { name: 'channelName', label: '开单渠道名称' } // ,
            // { name: 'aufsd', label: '是否冻结' }, // , translater: v => v === '冻结' ? 'Y' : 'N'
            // { name: 'loevm', label: '是否删除' }// , translater: v => v === 'X' ? 'Y' : 'N'
          ];
          option.filialeSelect = {
            filialeurl: '/sysSapDataSaleOrg/findSysSapDataSaleOrgListNoPage',
            filialeOpen: true
          }
          option.idField = 'kunnr'
        }
        this.$refs.dlg.open(option).then(item => {
          this.$refs.dlg.close()
          if (isSend) {
            this.getSelectItem1(item)
          } else {
            this.getSelectItem(item)
            this.fieldsToValidate('customerCode')
            this.mainForm.sysSapSendCode = '';
            this.mainForm.sysSapSendCodeName = ''
            // this.$refs.form.validateField(['customerCode']);
          }
        })
      },

      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
      // 选中SAP开单送达方：
      getSelectItem1(item) {
        // 开单客户代号
        this.mainForm.sysSapSendCode = item.kunnr1
        // this.mainForm.sysSapSendCodeName = item.kunnr1 + '  ' + item.name
        this.mainForm.sysSapSendCodeName = item.name
        this.fieldsToValidate('sysSapSendCode')
      },
      getSelectItem(item) {
        // 开单客户代号
        this.mainForm.sapCustomerCode = item.kunnr + ' ' + item.name
        this.mainForm.customerCode = item.kunnr
        this.mainForm.customerName = item.name
        // 送货分公司代号
        this.mainForm.wwDcompanyCode = item.lifnr || ''
        this.mainForm.wwDcompanyName = item.lifnrName || ''
        // 开单分公司代号
        this.mainForm.wwOcompanyCode = item.vkorg || ''
        this.mainForm.wwOcompanyName = item.vkorgName || ''
        this.mainForm.deleted = item.loevm
        this.mainForm.frozen = item.aufsd
        // 达能开单渠道分销渠道代号
        this.mainForm.wwOpeningOrderChannel = (item.vtweg || '') + (item.spart || '') + '  ' + (item.channelName || '')
        // console.log(item)
        // console.log('------------')
      }
    },
    mounted() {
    },
    created() {
      methodPost('/bill/findSysBillSampleList', { "pageNo": 1, "pageSize": 100 }).then(res => {
        this.systems = res.data;
        // console.log(res);
        if (this.id) {
          methodGet(`/account/findSapCustomerBillById/${this.id}`).then(({ data }) => {
            this.mainForm = {
              system: this.systems.find(o => o.code === data.sysCode),
              sysCode: data.sysCode,
              sysName: data.sysName,
              sysStoreCode: data.sysStoreCode,
              sysStoreName: data.sysStoreName,
              customerCode: data.customerCode || '',
              customerName: data.customerName || '',
              sapCustomerCode: data.customerCode + ' ' + data.customerName,
              sysSapSendCode: data.sysSapSendCode || '',
              sysSapSendCodeName: (data.sysSapSendName || ''), // (data.sysSapSendCode || '') + ' ' +
              sort: data.sort, // 匹配优先级序号
              sysSapText: data.sysSapText, // SAP开单分类文本
              orderType: data.orderType, // 订单别
              sysOther: data.sysOther, // 系统其他判断字段
              sysDestinationRemark: data.sysDestinationRemark,
              sysDestinationName: data.sysDestinationName || '', // 系统送货地名称
              sysDestinationCode: data.sysDestinationCode || '', // 系统送货地代号
              frozen: data.aufsd,
              deleted: data.loevm,
              goodAge: data.goodAge + 0,
              wwDcompanyCode: data.wwDcompanyCode || '', // 达能送货分公司
              wwDcompanyName: data.wwDcompanyName || '', // 达能开单分公司名称
              wwOcompanyCode: data.wwOcompanyCode || '', // 达能开单分公司
              wwOcompanyName: data.wwOcompanyName || '', // 达能开单分公司名称
              wwOpeningOrderChannel: (data.channel || '') + (data.productSpart || '') + ' ' + data.channelName // 达能开单渠道
            }
          })
        }
      })
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>
   .no-b-b{
     box-shadow: none;
     border: none;
   }
</style>



// WEBPACK FOOTER //
// src/_app/wwka/src/views/sapKaidanKehuList/index.vue